import { ProcessGroupIcon } from "@avenueops/shared-types";
import { Avatar } from "@avenueops/web-components";
import { TableRow as AvenueTableRow, TableCell as AvenueTableCell, TableHead as AvenueTableHead } from "@avenueops/web-components";

interface Props {
  rowId: string;
  title: string;
  count: number;
  icon?: ProcessGroupIcon;
  span: number;
}

export function ProcessTableRowHeader({ rowId, title, count, icon, span }: Props): JSX.Element {
  return (
    <AvenueTableRow key={rowId} className="bg-gray-50">
      <AvenueTableHead colSpan={span} className="w-full">
        <div className="flex flex-row items-center w-[90%]">
          {icon ? (
            <div className="mr-4">
              <Avatar type={icon.type} src={icon.value} />
            </div>
          ) : null}
          <span className="max-w-full truncate">
            {title} ({count})
          </span>
        </div>
      </AvenueTableHead>
    </AvenueTableRow>
  );
}
